/* eslint-disable import/prefer-default-export */
import { ADD_MARKETINGSITES } from './actionTypes';

export const addMarketingsites = sites => ({
    type: ADD_MARKETINGSITES,
    value: sites,
});
